import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { ActoCondicionModel } from 'src/app/models/acto-condicion/ActoCondicionModel';
import { FilterActoCondicionModel } from 'src/app/models/acto-condicion/FilterActoCondicionModel';
import { CategoriaHipoModel } from 'src/app/models/categoria-hipo/CategoriaHipoModel';
import { FilterCategoriaHipoModel } from 'src/app/models/categoria-hipo/FilterCategoriaHipoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
import { FilterGbuModel } from 'src/app/models/gbu/FilterGbuModel';
import { GbuModel } from 'src/app/models/gbu/GbuModel';
import { HipoAccionModel } from 'src/app/models/hipo/HipoAccionModel';
import { HipoModel } from 'src/app/models/hipo/HipoModel';
import { IActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IActoCondicionModel';
import { IFilterActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IFilterActoCondicionModel';
import { ICategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/ICategoriaHipoModel';
import { IFilterCategoriaHipoModel } from 'src/app/models/interfaces/categoria-hipo/IFilterCategoriaHipoModel';
import { IFilterGbuModel } from 'src/app/models/interfaces/gbus/IFilterGbuModel';
import { IGbuModel } from 'src/app/models/interfaces/gbus/IGbuModel';
import { IHipoModel } from 'src/app/models/interfaces/hipo/IHipoModel';
import { IFilterProyectoModel } from 'src/app/models/interfaces/proyectos/IFilterProyectoModel';
import { IProyectoModel } from 'src/app/models/interfaces/proyectos/IProyectoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { IFilterTipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/IFilterTipoEmpleadoModel';
import { ITipoEmpleadoModel } from 'src/app/models/interfaces/tipo-empleado/ITipoEmpleadoModel';
import { IFilterTipoReglaModel } from 'src/app/models/interfaces/tipo-regla/IFilterTipoReglaModel';
import { ITipoReglaModel } from 'src/app/models/interfaces/tipo-regla/ITipoReglaModel';
import { FilterProyectoModel } from 'src/app/models/proyecto/FilterProyectoModel';
import { ProyectoModel } from 'src/app/models/proyecto/ProyectoModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { FilterTipoEmpleadoModel } from 'src/app/models/tipo-empleado/FilterTipoEmpleadoModel';
import { TipoEmpleadoModel } from 'src/app/models/tipo-empleado/TipoEmpleadoModel';
import { FilterTipoReglaModel } from 'src/app/models/tipo-regla/FilterTipoReglaModel';
import { TipoReglaModel } from 'src/app/models/tipo-regla/TipoReglaModel';
import { ActoCondicionService } from 'src/app/services/acto-condicion/acto-condicion.service';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CategoriaHipoService } from 'src/app/services/categoria-hipo/categoria-hipo.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ContratistaService } from 'src/app/services/contratista/contratista.service';
import { GbuService } from 'src/app/services/Gbu/gbu.service';
import { HipoService } from 'src/app/services/hipo/hipo.service';
import { ProyectoService } from 'src/app/services/proyecto/proyecto.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { TipoEmpleadoService } from 'src/app/services/tipo-empleado/tipo-empleado.service';
import { TipoReglaService } from 'src/app/services/tipo-regla/tipo-regla.service';
import { HiposAccionRegistrarDialogComponent } from '../hipos-accion-registrar-dialog/hipos-accion-registrar-dialog.component';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { IFilterTipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/IFilterTipoAccidenteModel';
import { FilterTipoAccidenteModel } from 'src/app/models/tipo-accidente/FilterTipoAccidenteModel';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './hipos-seguimiento-registrar.component.html',
  styleUrls: ['./hipos-seguimiento-registrar.component.css']
})
export class HiposSeguimientoRegistrarComponent implements OnInit {
  model: IHipoModel;
  myControl = new FormControl();
  filteredOptions!: Observable<ContratistaModel[]>;
  listaContratistas: ContratistaModel[] = new Array<ContratistaModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCategorias: ICategoriaHipoModel[] = new Array<CategoriaHipoModel>();
  listaTipoRegla: ITipoReglaModel[] = new Array<TipoReglaModel>();
  listaTipoEmpleado: ITipoEmpleadoModel[] = new Array<TipoEmpleadoModel>();
  listaActoCondicion: IActoCondicionModel[] = new Array<ActoCondicionModel>();
  listaTipoAccidente: ITipoAccidenteModel[] = new Array<TipoAccidenteModel>();
  listaProyectos: IProyectoModel[] = new Array<ProyectoModel>();
  listaGbus: IGbuModel[] = new Array<GbuModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();


  public bankServerSideCtrl: FormControl = new FormControl();

  /** control for filter for server side. */
  public bankServerSideFilteringCtrl: FormControl = new FormControl();

  /** indicate search operation is in progress */
  public searching = false;

  /** list of banks filtered after simulating server side search */
  public filteredServerSideBanks: ReplaySubject<ContratistaModel[]> = new ReplaySubject<ContratistaModel[]>(1);

  protected _onDestroy = new Subject<void>();

  @ViewChild('singleSelect', { static: true }) singleSelect!: MatSelect;

  displayedColumns: string[] = ['detalle', 'fechalimite', 'fecharealcierre', 'estado', 'acciones'];

  constructor(
    public dialog: MatDialog,
    private dialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private router: Router,
    private service: HipoService,
    private categoriaService: CategoriaHipoService,
    private tiporeglaService: TipoReglaService,
    private contratistaService: ContratistaService,
    private sedeService: SedeService,
    private gbuService: GbuService,
    private proyectoService: ProyectoService,
    private tipoEmpleadoService: TipoEmpleadoService,
    private tipoAccidenteService: TipoAccidenteService,
    private actoCondicionService: ActoCondicionService,
    private storage: StorageService,
  ) {
    this.model = new HipoModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.model.idCompaniaSelected = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {

    this.companiaChanged();
    const filterGbu: IFilterGbuModel = new FilterGbuModel();
    this.gbuService
      .getAllList(filterGbu)
      .subscribe((data: IGbuModel[]) => {
        this.listaGbus = data;
      });

    const filterCategoria: IFilterCategoriaHipoModel = new FilterCategoriaHipoModel();
    this.categoriaService.getAllList(filterCategoria)
      .subscribe((data) => {
        this.listaCategorias = data;
      });

    const filterProyecto: IFilterProyectoModel = new FilterProyectoModel();
    this.proyectoService.getAllList(filterProyecto)
      .subscribe((data) => {
        this.listaProyectos = data;
      });

    const filterTipoRegla: IFilterTipoReglaModel = new FilterTipoReglaModel();
    this.tiporeglaService.getAllList(filterTipoRegla)
      .subscribe((data) => {
        this.listaTipoRegla = data;
      });

    const filterTipoEmpleado: IFilterTipoEmpleadoModel = new FilterTipoEmpleadoModel();
    this.tipoEmpleadoService.getAllList(filterTipoEmpleado)
      .subscribe((data) => {
        this.listaTipoEmpleado = data;
      });

    const filterTipoAccidente: IFilterTipoAccidenteModel = new FilterTipoAccidenteModel();
    this.tipoAccidenteService.getAllList(filterTipoAccidente)
      .subscribe((data) => {
        this.listaTipoAccidente = data;
      });

    const filterActoCondicion: IFilterActoCondicionModel = new FilterActoCondicionModel();
    this.actoCondicionService.getAllList(filterActoCondicion)
      .subscribe((data) => {
        this.listaActoCondicion = data;
      });

    // const contratistaFilter = new FilterContratistaModel();
    // this.contratistaService
    //   .getListWithEngie(contratistaFilter)
    //   .subscribe((data: ContratistaModel[]) => {        

    //     this.listaContratistas = data;

    //     this.bankServerSideCtrl.setValue(this.model.idContratista);//this.listaContratistas.find(bank => bank.idContratista === this.model.idContratista));

    //     var lista = data.filter(p => p.idContratista === this.model.idContratista);        
    //     this.filteredServerSideBanks.next(lista.slice());
    //   });

    // // listen for search field value changes
    // this.bankServerSideFilteringCtrl.valueChanges
    // .pipe(
    //   filter(search => !!search),
    //   tap(() => this.searching = true),
    //   takeUntil(this._onDestroy),
    //   debounceTime(200),
    //   map(search => {
    //     if (!this.listaContratistas) {
    //       return [];
    //     }

    //     // simulate server fetching and filtering data
    //     return this.listaContratistas.filter(bank => bank.nombre.toLowerCase().indexOf(search.toLowerCase()) > -1);
    //   }),
    //   delay(500),
    //   takeUntil(this._onDestroy)
    // )
    // .subscribe(filteredBanks => {
    //   this.searching = false;
    //   this.filteredServerSideBanks.next(filteredBanks);
    // },
    // error => {
    //   // no errors in our simulated example
    //   this.searching = false;
    //   // handle error...
    // });  

  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.idSedeSelected = undefined;
    const filterSede: IFilterSedeModel = new FilterSedeModel();
    if (this.model.idCompaniaSelected)
      filterSede.companias.push(this.model.idCompaniaSelected);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
        this.listarContratistas();
      });
  }

  sedeChanged() {
    this.listarContratistas();
  }


  listarContratistas(): void {
    this.listaContratistas = [];
    this.bankServerSideCtrl.setValue([]);
    if (this.model.idCompaniaSelected && this.model.idSedeSelected) {

      let contratistaFilter = new FilterContratistaModel();
      contratistaFilter.companias.push(this.model.idCompaniaSelected);
      contratistaFilter.idSede = this.model.idSedeSelected;
      this.contratistaService
        .getList(contratistaFilter)
        .subscribe((data: ContratistaModel[]) => {
          this.listaContratistas = data;
          this.bankServerSideCtrl.setValue(this.model.idContratista);
          var lista = data.filter(p => p.idContratista === this.model.idContratista);
          this.filteredServerSideBanks.next(lista.slice());

        });

      // listen for search field value changes
      this.bankServerSideFilteringCtrl.valueChanges
        .pipe(
          filter(search => !!search),
          tap(() => this.searching = true),
          takeUntil(this._onDestroy),
          debounceTime(200),
          map(search => {
            if (!this.listaContratistas) {
              return [];
            }

            return this.listaContratistas.filter(bank => bank.nombre.toLowerCase().indexOf(search.toLowerCase()) > -1);
          }),
          delay(500),
          takeUntil(this._onDestroy)
        )
        .subscribe(filteredBanks => {
          this.searching = false;
          this.filteredServerSideBanks.next(filteredBanks);
        },
          error => {
            // no errors in our simulated example
            this.searching = false;
          });
    }
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      this.alertDialogService.open('Debe ingresar en campos requeridos');
    } else {
      if (this.model.idSedeSelected)
        this.model.idSede = this.model.idSedeSelected;
      if (this.model.idGbuSelected)
        this.model.idGbu = this.model.idGbuSelected;
      if (this.model.idTipoReglaSelected)
        this.model.idTipoRegla = this.model.idTipoReglaSelected;
      if (this.model.tiempoPerdidoSelected)
        this.model.tiempoPerdido = this.model.tiempoPerdidoSelected == 1;
      if (this.model.idCategoriaHipoSelected)
        this.model.idCategoriaHipo = this.model.idCategoriaHipoSelected;
      if (this.model.idActoCondicionSelected)
        this.model.idActoCondicion = this.model.idActoCondicionSelected;
      if (this.model.idTipoEmpleadoSelected)
        this.model.idTipoEmpleado = this.model.idTipoEmpleadoSelected;
      if (this.model.idTipoAccidenteSelected)
        this.model.idTipoAccidente = this.model.idTipoAccidenteSelected;
      if (this.model.idCompaniaSelected)
        this.model.idCompania = this.model.idCompaniaSelected;


      if (this.validar()) {
        this.dialogService.open('¿Deseas guardar los cambios?'); //options
        this.dialogService.confirmed().subscribe((confirmed) => {
          if (confirmed) {
            // this.saveData();
            this.submitForm();
          }
        });
      }
    }
  }

  validar(): boolean {
    let errors = 0;

    if (this.model.idContratista === 0 || this.model.idContratista === undefined) {
      this.alertDialogService.open('Debe seleccionar un contratista');
      errors++;
    }

    return errors == 0;
  }

  submitForm() {
    this.service.submit(this.model).subscribe((result: ActionResultModel) => {
      if (result.type != eTypeResult.SUCCESS) {
        this.alertDialogService.open(result.message);
      }
      else {
        this.alertDialogService.open('La información fue registrada.'); //options          
        this.router.navigate(['/hipos']);
      }
    });
  }

  closed() {
    this.dialogService.open('Se perderán los cambios no guardados ¿esta seguro de salir?'); //options
    this.dialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.router.navigate(['/hipos']);
      }
    });
  }
  allowedChars: number[] = [37, 39, 46];

  check(event: KeyboardEvent, maxLength: number, value: any) {
    if (event.keyCode > 31 && !this.allowedChars.includes(event.keyCode) && value && value.toString().length + 1 > maxLength) {
      event.preventDefault();
    }
  }

  openDialogAccion(item?: HipoAccionModel): void {
    if (item == null)
      item = new HipoAccionModel();


    // console.log(tipoDocumento);
    const dialogRef = this.dialog.open(HiposAccionRegistrarDialogComponent, {
      width: '900px',
      data: item,
    });

    dialogRef.afterClosed().subscribe((result: HipoAccionModel) => {
      // this.animal = result;
      if (result) {
        if (result.index == 0) {
          if (this.model.acciones.length > 0)
            result.index = this.model.acciones[this.model.acciones.length - 1].index + 1;
          else
            result.index = 1;
          this.model.acciones.push(result);

        }
        else {
          this.model.acciones[this.model.acciones.findIndex(item => item.index == result.index)] = result;
        }
        const temp = JSON.stringify(this.model.acciones);
        this.model.acciones = JSON.parse(temp);
      }
    });
  }

  eliminarAccion(item: HipoAccionModel): void {
    this.model.acciones.splice(this.model.acciones.findIndex(p => p.index == item.index), 1);
    const temp = JSON.stringify(this.model.acciones);
    this.model.acciones = JSON.parse(temp);
  }

  public optionsSINO = [
    { "id": 1, "nombre": "SI" },
    { "id": 0, "nombre": "NO" }
  ]
}